import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';

/*
export const environment = {
  production: false,
  gtmId: 'GTM-XXXXXXX' // Replace with a default or leave empty
};

export interface IGoogleInfo {
  production: boolean,
  gtmId: string // Replace with a default or leave empty
};
*/

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  //private gtmId = environment.gtmId;

  constructor(private setting: SettingService) { }

  

  public init(gtmIdOverride?: string): void {
    if(this.setting.configuration?.googleTagsConfiguration){
      if(this.setting.configuration?.googleTagsConfiguration?.googleTagsInstallHeader && this.setting.configuration?.googleTagsConfiguration?.googleTagsInstallBody) {
        try {
          /*
          const id = gtmIdOverride || this.gtmId;
          if (!id) {
            console.warn('GTM ID is not set');
            return;
          }*/
  
          if (document.getElementById('gtm-script')) {
            return;
          }
  
          // Create script
          const script = document.createElement('script');
          script.id = 'gtm-script';
          var cleanedHeader = this.setting.configuration?.googleTagsConfiguration?.googleTagsInstallHeader;
          cleanedHeader = cleanedHeader.replace(/<!--[\s\S]*?-->/g, '');
          cleanedHeader = cleanedHeader.replace(/<\/?script[^>]*>/gi, '');
          script.innerHTML = cleanedHeader;
          /*
          script.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${id}');
          `;
          */
          document.head.appendChild(script);
  
          // Add <noscript> iframe dynamically to body
          const noscript = document.createElement('noscript');
          var cleanedBody = this.setting.configuration?.googleTagsConfiguration?.googleTagsInstallBody;
          cleanedBody = cleanedBody.replace(/<!--[\s\S]*?-->/g, '');
          cleanedBody = cleanedBody.replace(/<\/?noscript[^>]*>/gi, '');
          noscript.innerHTML = cleanedBody;
          /*
          noscript.innerHTML = `
            <iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
          `;
          */
          document.body.insertBefore(noscript, document.body.firstChild);
        } catch (error) {
          console.log("error trying to use google tags!");
        }
      }

    }
  }
}
